import CrossSellTitle from './CrossSellTitle';
export default CrossSellTitle;
